<template>
    <div style="padding: 20px">
        <v-card class="mx-auto">
            <v-layout wrap>
                <v-flex xs12 sm12 md4 lg4 xl4>
                    <i-tree has-search
                            enabled-add
                            get-child-url="/department/searchTree"
                            get-root-url="/department/searchTree"
                            item-text="name"
                            item-key="departmentId" :active.sync="active" ref="tree" @add="addNew"></i-tree>
                </v-flex>
                <v-flex xs12 sm12 md8 lg8 xl8>
                    <CCreateForm :input-items="createItems" :form-name="$t('lang.department.info')"
                                 :default-data="item" ref="createForm" create-url="/department/save"
                                 @cancel="onSearch"
                                 enable-delete
                                 delete-url="/department/delete"
                                 @save="onUpdate"
                    ></CCreateForm>
                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>

<script>
    import {userContants} from "@/constants";
    import axios from "axios";
    import ITree from "../../../components/form/Tree";
    import DeptEdit from "./DeptEdit";
    import CCreateForm from "../../../components/form/CreateForm";

    export default {
        name: 'DeptList',
        components: {CCreateForm, ITree},
        data: () => {
            return {
                search: "",
                active: [],
                open: [],
                items: [],
                item: {},
                selected: [],
                createItems: [
                    {
                        type: "text",
                        name: "name",
                        label: "lang.department.name",
                        validate: "required",
                        maxlength: '250',
                        placeHolder: "",
                        errorText: "Lỗi"
                    },
                    {
                        type: "text",
                        name: "code",
                        label: "lang.department.code",
                        validate: "required",
                        maxlength: '250',
                        placeHolder: ""
                    },
                    {
                        type: "text",
                        name: "address",
                        label: "lang.department.address",
                        validate: "",
                        maxlength: '250',
                        placeHolder: ""
                    },
                    {
                        type: "text",
                        name: "phone",
                        label: "lang.department.phone",
                        validate: "phone",
                        maxlength: '20',
                        placeHolder: ""
                    },
                    {
                        type: "text",
                        name: "email",
                        label: "lang.department.email",
                        validate: "email",
                        maxlength: '50',
                        placeHolder: ""
                    },
                    {
                        type: "tree",
                        name: "parentId",
                        textValue: "parentName",
                        label: "lang.department.parent",
                        validate: "",
                        maxlength: '50',
                        placeHolder: "",
                        itemKey: "departmentId",
                        itemText: "name",
                        getRootUrl: "/department/searchTree",
                        getChildUrl: "/department/searchTree"
                    }
                ],

                pagination: {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10,
                    sortBy: "updated_at",
                    totalItems: 0,
                    rowsPerPageItems: [10, 20],
                    paging: true
                }
            }
        },

        watch: {
            active: function (value) {
                //console.log(value);
                if (value.length > 0) {
                    this.updateForm(value[0]);
                }
            }

        },

        computed: {},

        methods: {
            addNew: function () {
                this.item = {};
            },

            updateParentName: function (department) {
                axios.post(process.env.VUE_APP_API_URL + "/department/search", {
                    'departmentId': department.parentId,
                    'status': 1
                }).then(data => {
                    if (data.items.length > 0) {
                        department.parentName = data.items[0].name;
                        this.item = department;
                        //console.log(this.item);
                    }
                })
            },

            updateForm: function (department) {
                //document.getElementById("createDiv").style.display = "";
                if (department.parentId != undefined && department.parentId != null) {
                    this.updateParentName(department);
                } else {
                    this.item = department;
                }
            },

            onUpdate: function (data) {
                //this.$refs.tree.updateNodeItem(this.item);
                this.$refs.tree.updateAll();
                //this.$refs.tree.closeAll();
            },

            onSearch: function () {
                //console.log(this.item);
                this.$refs.tree.updateAll();
                //this.$refs.tree.closeAll();
            }
        },

        created() {
        },
    }
</script>
